// kula_contact_resumes renders the SAME candidate as a search result does, so
// it reuses the one profile card instead of hand-rolling a second profile
// layout. The tool already carries the resumes, so we hand them straight to
// the card (no refetch); the card fills in name/experience/education/skills
// from the contact record.

import { CandidateProfileCard } from '../candidateProfiles/CandidateProfileCard';
import { fromResumeFiles } from '../candidateProfiles/toResumeAttachments';
import type { CandidateSummary } from '../../../types';
import type { ResumeBlockProps } from './ResumeBlock.types';

export const ResumeBlock = ({ data }: ResumeBlockProps) => {
  const resumes = data.resumes ?? [];
  if (resumes.length === 0) return null;

  // Seed the card from the parsed CV so it has a name/headline to show while
  // the contact record loads; the fetched contact overrides these.
  const parsed = resumes[0].parsed ?? {};
  const candidate: CandidateSummary = {
    id: String(data.contactId),
    name: parsed.name ?? resumes[0].fileName,
    headline: parsed.currentJobTitle ?? '',
    tags: [],
    yearsExperience: parsed.totalExperienceYears,
  };

  return (
    <CandidateProfileCard
      candidate={candidate}
      active
      resumes={fromResumeFiles(resumes)}
    />
  );
};
